import * as React from 'react';

import { useIntegratorMany } from 'ui-model';

import { RolloutEnum } from '@lib/resources/types';

import usePermissions from 'hooks/usePermissions';
import { ESyncType } from 'resources';

export default function useIntegrationHealthMenu() {
  const { data } = useIntegratorMany({ enabled: true });
  const { hasAccessToProduct } = usePermissions();
  // @ts-ignore
  const settings = React.useMemo(() => data?.pages?.[0]?.[0]?.settings?.integrator, [data]);
  const hasAccessToNewSync = hasAccessToProduct(RolloutEnum.NewSync);

  const hasAccessToBlocks = hasAccessToNewSync && settings?.syncBlocks;
  const hasAccessToWhitespaces = hasAccessToNewSync && settings?.syncWhitespaces;
  const hasAccessToRecalls = hasAccessToNewSync && settings?.syncRecalls;
  const hasAccessToReferrals = hasAccessToNewSync && settings?.syncReferrals;

  const filterIntegrationHealthMenu = React.useCallback(
    (key: string) => {
      switch (key) {
        case ESyncType.Blocks:
          return hasAccessToBlocks;
        case ESyncType.Whitespaces:
          return hasAccessToWhitespaces;
        case ESyncType.Recalls:
          return hasAccessToRecalls;
        case ESyncType.Referrals:
          return hasAccessToReferrals;
        default:
          return true;
      }
    },
    [hasAccessToBlocks, hasAccessToRecalls, hasAccessToReferrals, hasAccessToWhitespaces],
  );

  return { filterIntegrationHealthMenu };
}
